import { W9FormData, W9TaxClassifications } from '@bybeam/platform-types';
import RadioGroup from '@platform-ui-common/components/RadioGroup/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import {
  fieldUpdate,
  resetForm as resetFormAction,
} from '@platform-ui-common/hooks/useForm/index.js';
import { FormProps } from '@platform-ui-common/types/index.js';
import Panel from './Panel.js';
import { initialData } from './constants.js';

const taxClassificationItems = [
  { label: 'Individual', value: W9TaxClassifications.INDIVIDUAL },
  { label: 'Business', value: W9TaxClassifications.BUSINESS },
];

const TaxClassification = ({
  formData,
  errors,
  dispatch,
  resetForm,
}: FormProps<W9FormData> & { resetForm: () => void }): JSX.Element => {
  return (
    <Panel>
      <Typography variant="body">Tax classification:*</Typography>
      <RadioGroup
        name="taxClassification"
        selectedValue={formData.taxClassification}
        onChange={(value): void => {
          // we reset the form to avoid edge cases where the other fields are marked as being errored
          // when in reality they haven't been filled yet
          dispatch(resetFormAction(initialData));
          resetForm();
          dispatch(fieldUpdate('taxClassification', value as W9TaxClassifications));
        }}
        items={taxClassificationItems}
        error={!!errors.taxClassification}
      />
    </Panel>
  );
};

export default TaxClassification;
